import base from './baseApi';

const { urls, methods, execute } = base();

const signOutUser = async (id: string) => {
  const method = methods.POST;
  const url = urls.auth.signOut;
  const response = await execute(method, url, { authorization: true }, { userId: id });

  return response;
}

export {
  signOutUser
};
